import {findReportTypeSection} from 'ducks/reportSections';

export const insertFloorPlanSections = (reportSections, sections) => {
  const floorPlanSection = findReportTypeSection(reportSections, 'FLOOR_PLAN');
  const floorPlanIndex = sections.findIndex(({name}) => name === 'FLOOR_PLAN');
  if (floorPlanIndex > -1 && floorPlanSection.included) {
    const floorPlanSections = floorPlanSection.sectionData.floorPlanUris.map(url => ({
      name: 'FLOOR_PLAN',
      title: floorPlanSection.sectionData.title,
      data: {
        floorPlanPhoto: url
      }
    }));
    sections.splice(floorPlanIndex, 1, ...floorPlanSections);
  }
};